<div #scrollContainer
  class="absolute right-0 w-80 mobile:left-1/2 mobile:w-[70vw] mobile:top-[60px] mobile:transform mobile:-translate-x-1/2 mobile:right-auto bg-white border border-border rounded-3xl shadow-lg z-50 max-h-[80vh] overflow-y-auto scrollbar-hide"
  (scroll)="onScroll($event)">
  <div *ngIf="notifications.length > 0">
    <div *ngFor="let notification of notifications" class="p-4 border-b last:border-b-0 cursor-pointer hover:bg-border"
      (mouseenter)="markAsRead.emit(notification.id)" (click)="markAsRead.emit(notification.id)"
      [ngClass]="notification.is_read ? 'bg-white' : (notification.type == alertType ? 'bg-error-100' : 'bg-warning-100')">

      <div class="font-semibold text-black">
        @if(notification.translate_in_frontend){
        {{ notification.title | transloco: notification.title_params }}
        } @else {
        {{ notification.title }}
        }
      </div>

      <div class="text-sm text-neutral-800 mt-1">

        @if (notification.translate_in_frontend) {
        {{ isExpanded(notification.id)
        ? (notification.body | transloco: notification.body_params)
        : (notification.body | transloco: notification.body_params | slice: 0:100) }}
        } @else {
        {{ isExpanded(notification.id)
        ? notification.body
        : (notification.body | slice: 0:100) }}
        }

        <span *ngIf="(((notification.translate_in_frontend
              ? (notification.body | transloco: notification.body_params)
              : notification.body) || '').length) > 100" class="text-primary ml-1 cursor-pointer"
          (click)="toggleExpand(notification.id); $event.stopPropagation()">
          @if(isExpanded(notification.id)) { {{ 'shared.view_less' | transloco }} } @else { {{ 'shared.view_more' |
          transloco }} }
        </span>

      </div>
      <div class="text-neutral-500 text-xs">{{ notification.created_at | isoDate }}</div>
    </div>
    <div *ngIf="waitingForNextPageResponse" class="flex w-full justify-center"><span
        class="loading loading-dots loading-sm"></span></div>
  </div>
</div>